import { useCallback } from 'react';

import type { QueryParams } from '../../../utils/url';
import {
  createOptionsParamValue,
  createRangeMaxParamName,
  createRangeMinParamName,
} from '../../ClearAllFiltersButton';

export const useFilterHandlers = (onFilterChange: (queryParams: QueryParams) => void) => {
  const onFilterOptionChange = useCallback(
    (filterKey: string, optionsKeys: string[]) => {
      onFilterChange({ [filterKey]: createOptionsParamValue(optionsKeys) });
    },
    [onFilterChange]
  );

  const onFilterRangeChange = useCallback(
    (filterKey: string, { newMin, newMax, min, max }: any) => {
      onFilterChange({
        [createRangeMinParamName(filterKey)]: newMin !== min ? newMin : '',
        [createRangeMaxParamName(filterKey)]: newMax !== max ? newMax : '',
      });
    },
    [onFilterChange]
  );

  return { onFilterOptionChange, onFilterRangeChange };
};
